import * as types from '../mutation-types'
import {
    getGoodsDetailData,
    setGoodsDetailData
} from '../../utils/auth'

// initial state
const state = {
    goodsDetailData: getGoodsDetailData(), // 新人权益订单数
}

// getters
const getters = {
    getGoodsDetailData: state => state.goodsDetailData
}

// mutations
const mutations = {
    [types.SET_GOODS_DETAIL_DATA](state, goodsDetailData) {
        state.goodsDetailData = goodsDetailData
        setGoodsDetailData(goodsDetailData)
    }
}
// actions
const actions = {
}

export default {
    state,
    getters,
    actions,
    mutations
}
